export const EMPLOYEE_PREV_EXP = "employee_prev_exp";
export const EMPLOYEE_PREV_EXP_SUCCESS = "employee_prev_exp_success";
export const EMPLOYEE_PREV_EXP_FAILURE = "employee_prev_exp_failure";
